import { connect } from 'react-redux'
import { concat, of } from 'rxjs'
import { RESPONSE_PENDING } from 'libraries/front-end-core/constants/responses'
import { getSmartSearchResults } from 'services/SearchService'
import { setCurrentSearchPhrase } from 'redux/actions'
import SmartSearchDataSubscriber from './SmartSearchDataSubscriber'

const mapStateToProps = (state, ownProps) => ({
  aolConfigLoaded: state.aol.aolConfigLoaded,
  flavour: state.layout.flavour,
  pageParameters: state.page.configParameters,
  headerHeight: state.layout.headerHeight,
  isMobile: state.layout.deviceType.isMobile,
  hasSmartFeatures: state.user.hasSmartFeatures,
  isLogged: state.user.isLogged
})

const mapDispatchToProps = dispatch => ({
  setCurrentSearchPhrase: phrase => dispatch(setCurrentSearchPhrase(phrase))
})

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { flavour, hasSmartFeatures } = stateProps
  const { queryString, caseFlag, query = {} } = ownProps
  const selectedAols = query.aol
    ? [].concat(query.aol).map(aol => aol.toLowerCase())
    : []

  let response
  if (queryString && hasSmartFeatures === true) {
    response = concat(
      of(RESPONSE_PENDING),
      getSmartSearchResults({
        queryString,
        smartSearchEnabled: true,
        selectedAols,
        caseFlag,
        flavour
      })
    )
  } else {
    response = of({ foundQa: [] })
  }

  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    response
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(SmartSearchDataSubscriber)
